enum FulfillmentType {
    /**查看全部订单类型 */
    ALL = "",

    /**代销订单类型 */
    DROP_SHIPPING = "DROP_SHIPPING",

    /**自有订单类型 */
    SELF_SHIPPING = "SELF_SHIPPING",
}

export default FulfillmentType;
